function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
export var mouseoverHandler = _ref => {
  var _ref$onMouseIn = _ref.onMouseIn,
    onMouseIn = _ref$onMouseIn === void 0 ? () => {} : _ref$onMouseIn,
    _ref$onMouseOut = _ref.onMouseOut,
    onMouseOut = _ref$onMouseOut === void 0 ? () => {} : _ref$onMouseOut;
  return _ref2 => {
    var currentTarget = _ref2.currentTarget;
    var handleMouseOut = evt => {
      var isChild = currentTarget.contains(evt.target) || currentTarget === evt.target;
      if (!isChild) {
        onMouseOut();
        document.removeEventListener('mouseover', handleMouseOut);
      }
    };
    onMouseIn();
    document.addEventListener('mouseover', handleMouseOut);
  };
};
var useMenuState = function useMenuState() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$method = _ref3.method,
    method = _ref3$method === void 0 ? 'click' : _ref3$method,
    _ref3$onChange = _ref3.onChange,
    onChange = _ref3$onChange === void 0 ? () => {} : _ref3$onChange;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    seenClick = _useState4[0],
    setSeenClick = _useState4[1];
  var isClick = method === 'click' || method === 'both';
  var isHover = method === 'hover' || method === 'both';
  var openMenu = () => {
    setIsOpen(true);
    onChange(true);
  };
  var closeMenu = () => {
    setIsOpen(false);
    onChange(false);
  };
  var onMouseOver = isHover ? mouseoverHandler({
    onMouseIn: openMenu,
    onMouseOut: closeMenu
  }) : () => {};
  var onClick = () => {
    if (isClick) {
      if (menuOpen && seenClick) {
        closeMenu();
      } else {
        openMenu();
      }
    }
    if (!seenClick) {
      setSeenClick(true);
    }
  };
  return {
    menuOpen,
    openMenu,
    closeMenu,
    menuHandlerProps: {
      onClick,
      onMouseOver
    }
  };
};
export default useMenuState;